
export class SystemUser{
    constructor(
        public name: string | null,
        public roles: string[],
        public id?: number
    ){}
}